/**
 * Layout Wrapper Component
 * Conditionally renders ClassicLayout or ModernLayout based on user preference
 */

import { ReactNode } from 'react';
import { useLayout } from './LayoutProvider';
import { ClassicLayout } from './ClassicLayout';
import { ModernLayout } from './ModernLayout';

export interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { layoutType } = useLayout();

  if (layoutType === 'modern') {
    return <ModernLayout>{children}</ModernLayout>;
  }

  return <ClassicLayout>{children}</ClassicLayout>;
}
